.aj{border-radius:0.625rem;}